module.exports = __webpack_public_path__ + "mobile.c70fd7c0.webp";